import { get } from './shared';

export const queryFacebookCountry = async (queryString: string) => {
  return await get(`api/query/facebook_countries?q=${queryString}`);
};

export const queryFacebookLocale = async (queryString: string) => {
  return await get(`api/query/facebook_locales?q=${queryString}`);
};
